import { Component, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { NgIf, NgClass } from '@angular/common';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { HeartHeaderComponent } from 'src/app/shared/lista-deseos/heart-header/heart-header.component';

@Component({
  selector: 'app-carpedmadventures',
  templateUrl: './carpedmadventures.component.html',
  styleUrls: ['./carpedmadventures.component.scss'],
  imports: [NgIf, NgClass, HeartHeaderComponent]
})
export class CarpedmadventuresComponent implements OnInit {

  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @Output() public headerHeight1: EventEmitter<any> = new EventEmitter();
  @ViewChild('header') headerRef!: ElementRef;

  constructor(
    public companyParamsService: CompanyParamsService
  ) { }
  showMenu: boolean = false;

  ngOnInit(): void {
  }

  renderMenu() {
    this.showMenu = !this.showMenu;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      var height = this.headerRef.nativeElement.offsetHeight;
      this.headerHeight.emit(height);
      this.headerHeight1.emit(height);
    }, 300);
  }

}
